Ext.define('SA.HistogramViewStateObserver', {
    constructor({targets, handler, scope}) {
        this.model = targets.model;
        this.project = targets.model.getProject();
        this.proxy = targets.proxy;
        this.projectView = targets.projectView;

        this.observable = new Ext.util.Observable();
        this.observable.on('change', handler, scope);

        this.initEvents();
    },

    initEvents() {
        SA.data.LocationAliases.on('change', this.fireChange, this);

        this.proxy.on('result', this.fireChange, this);
        this.projectView.on('resize', this.fireChange, this);

        this.model.on('set:data', this.fireChange, this);
        this.project.on('change:attribute', this.fireChange, this);
        this.project.on('change:location', this.fireChange, this);
        this.project.on('change:unitDiscoverable', this.fireChange, this);
    },

    fireChange() {
        this.observable.fireEvent('change');
    }
});